import { PaymentGroupName } from '@as-react/common-types';
export const PAYMENT_LOGO_IMAGE_PREFIX = '/content/dam/general/payment_logos/2025/';
export const getPaymentGroupImageUrl = (groupName, prefix) => {
    switch (groupName) {
        case 'maestro':
            return `${prefix}maestro.png`;
        case 'paypal':
            return `${prefix}paypal.png`;
        case 'ideal':
            return `${prefix}ideal.png`;
        case 'ideal_wero':
            return `${prefix}ideal-wero.png`;
        case 'bancontact_mistercash':
            return `${prefix}bancontact.png`;
        case 'visa':
            return `${prefix}visa.png`;
        case 'mastercard':
            return `${prefix}mastercard.png`;
        case 'American_Express_choice':
            return `${prefix}amex.png`;
        case 'vvv':
            return `${prefix}vvv.png`;
        case 'visa_delta':
            return `${prefix}visa.png`;
        case 'klarna':
            return `${prefix}klarna.png`;
        case 'sofort':
            return `${prefix}klarna_sofort.png`;
        case 'applepay':
            return `${prefix}applepay.png`;
        case 'googlepay':
            return `${prefix}googlepay.png`;
        case 'ecocheque_monizze':
            return `${prefix}monizze.png`;
        case 'ecocheque_pluxee':
            return `${prefix}pluxee.png`;
        case 'ecocheque_edenred':
            return `${prefix}edenred.png`;
        default:
            return '';
    }
};
export const getGroupName = (group) => {
    switch (group.name) {
        case PaymentGroupName.CARTE_BLEUE:
            return 'carteblue';
        default:
            return group.name.toLowerCase().replace(/\s/g, '');
    }
};
export const isAllPaymentOptionsValid = (group) => group.paymentOptions.every(option => { var _a; return !((_a = option.reasonNotValidForBasket) === null || _a === void 0 ? void 0 : _a.length) && !option.exceededMaxBasketCost; });
export const isSingleOption = (group) => group.paymentOptions.length === 1;
